import React from 'react';

import Checkbox from 'components/DesignSystem/Checkbox';
import Snackbar from 'components/DesignSystem/Snackbar';
import Location from 'types/Locations/Location';

import './index.scss';

export default function GroupedLocations({
  groupName,
  locations,
  isLocationSelected,
  toggleLocation,
}: {
  groupName: string;
  locations: Location[];
  isLocationSelected: (id: number) => boolean;
  toggleLocation: (id: number) => void;
}) {
  return (
    <div>
      <div className="grouped-location-section-header">
        <div className="horizontal-line" />
        {groupName}
        <div className="horizontal-line" />
      </div>
      {locations.length === 0 && (
        <Snackbar className="mt-2">
          Nenhum local encontrado para o grupo
          {` ${groupName}`}
        </Snackbar>
      )}
      {locations.map((l) => (
        <Checkbox
          key={l.id}
          label={l.name}
          checked={isLocationSelected(l.id)}
          onChange={() => toggleLocation(l.id)}
          className="my-2"
        />
      ))}
    </div>
  );
}
